import React from 'react';
import { useStyletron } from 'styletron-react';
import { Layer } from 'baseui/layer';

const MinWidthOverlay = () => {
  const [css] = useStyletron();

  const overlayStyle = css({
    display: 'none',
    '@media screen and (max-width: 1300px)': {
      display: 'flex',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 1)',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999,
    },
  });

  const messageStyle = css({
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    color: 'white',
    fontSize: '48px',
  });

  return (
    <Layer>
      <div className={overlayStyle}>
        <div className={messageStyle}>
          Small screens are  not supported.
        </div>
      </div>
    </Layer>
  );
};

export default MinWidthOverlay;
